export enum NotificationTypeEnum {
  ShowOverlay,
  HideOverlay,
  ShowSnackbar
}
